import { render, staticRenderFns } from "./DomainUserNew.vue?vue&type=template&id=280366a0&"
import script from "./DomainUserNew.vue?vue&type=script&lang=js&"
export * from "./DomainUserNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports